import { useWindowSize } from '@vueuse/core';

import { ref } from 'vue';

const screen = ref({
  isMobile: null,
});

export default function useDisplay() {
  const updateDisplay = () => {
    const { width } = useWindowSize();
    screen.value.isMobile = width.value < 600;
  };

  return {
    updateDisplay,
    screen,
  };
}
